import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { EditViewAction } from '../../../actions/spaces/EditViewAction';
import { openBlankWindow, setWindowLocation } from '../SpacesSagaHelpers';
import { getViewDetailInfo } from './ContentDetailSagas';

// When a new window is created, if it's not part of a click event handler it will be detected by browsers as a pop-up.
// Because we are opening a new window in the edit workbook saga which is async, to get around the pop up blocker we need
// to open the window first, then the window.location.href can be set asynchronously afterwards
export function* handleEditViewAction(action: EditViewAction) {
  let newWindow: Window = null;
  try {
    newWindow = openBlankWindow();
    const viewDetailInfo = yield call(getViewDetailInfo, action.view);
    setWindowLocation(newWindow, viewDetailInfo.editUrl);
  } catch (e) {
    newWindow && newWindow.close();
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
